// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"29":"ebd5d059","315":"c0b7b595"}[chunkId] + ".chunk.css";
};